import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/events/redux/actions';
import * as homeActions from '../../features/home/redux/actions';
import * as datasourceActions from '../../features/data-connector/redux/actions';
import CustomLoader from '../common/CustomLoader';
import EventForm from './EventForm';
import NewEventAction from './NewEventAction';
import { drapcodeIcon } from '../../common/custom/icon-library';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownItem,
  UncontrolledDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import voca from 'voca';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import showAlert from '../../common/utils/alert';
import { APP_WRITE, DIRECTUS, EVENT, MYSQL, SUPABASE, XANO } from 'drapcode-constant';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';

export class EditEvent extends Component {
  static propTypes = {
    events: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    flag: false,
  };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, eventId, version } = match.params;
    actions.loadProjectDetailEvent({ projectId, version });
    actions.loadEventDetail({ projectId, eventId, version });
    actions.loadPagesInEvent({ projectId, version });
    actions.loadDefaultPage({ projectId, version });
    actions.loadCollectionsInEvent({ projectId, version });
    actions.loadProjectPlugins({ projectId, version });
    actions.loadSnippetsInEvent({ projectId, version });
    actions.loadDatasourcesInEvent({
      projectId,
      version,
      types: [SUPABASE, DIRECTUS, APP_WRITE, XANO, MYSQL],
    });
    const permissionData = await actions.getPermissionFlags({ projectId });
    if (permissionData && permissionData.length > 0) {
      const events = permissionData.includes(EVENT);
      this.setState({ flag: events });
    }
  }

  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    if (nextProps.match.url !== this.props.match.url) {
      const { projectId, eventId, version } = nextProps.match.params;
      nextProps.actions.loadEventDetail({ projectId, eventId, version });
    }
    return true;
  };

  handleDelete = () => {
    const { match, actions, events, history } = this.props;
    const { projectId, version } = match.params;
    const {
      selectedEvent: { uuid },
    } = events;
    const preConfirm = () => {
      actions.deleteEvent({ projectId, uuid, version }).then((res) => {
        actions.loadEvents({ projectId, version });
        history.push(`/2.0/events/${version}/v/${projectId}`);
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  showEditEventForm = () => {
    const { events, actions, match } = this.props;
    const { projectId, version } = match.params;
    const { flag } = this.state;
    const {
      selectedEvent,
      selectedAction,
      isOpenEventUpdateModel,
      updateEventPending,
      saveNewActionPending,
      updateActionPending,
      deleteActionPending,
      deleteEventPending,
      swapActionStepPending,
      enableActionPending,
    } = events;

    if (!selectedEvent) {
      return 'No event available';
    }

    const showLoader = updateEventPending !== undefined && updateEventPending;
    const showLoaderForAction =
      (saveNewActionPending !== undefined && saveNewActionPending) ||
      (updateActionPending !== undefined && updateActionPending);
    const showLoaderForDeleteAction = deleteActionPending !== undefined && deleteActionPending;
    const showLoaderForDeleteEvent = deleteEventPending !== undefined && deleteEventPending;
    const showLoaderForSwapAction = swapActionStepPending !== undefined && swapActionStepPending;
    const showLoaderForEnableAction = enableActionPending !== undefined && enableActionPending;
    return (
      <>
        <div className="col-md-11 col-lg-11 col-sm-11 col-xs-12 drapcode">
          <div className="card">
            <div className="card-header card-header-icon" data-background-color="drapcode-violet">
              <i className={`wb ${drapcodeIcon('configure')}`}></i>
            </div>
            <div className="card-content">
              <div className="card-title-header row mx-auto">
                <h4
                  className="card-title col-10"
                  style={{ textTransform: 'revert' }}
                  title={`${selectedEvent.eventTitle} Actions`}
                >
                  {voca.truncate(selectedEvent.eventTitle, 60)}
                </h4>
                <div className="card-cta">
                  <UncontrolledDropdown group className="custom-pad-right-1 pr-2">
                    <DropdownToggle color="theme-warning" title="Modify" className="btn-md" caret>
                      <i className="wb webconnect-cogs"></i> Modify
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={actions.toggleEventUpdate} className="theme-green">
                        <i className="wb webconnect-pencil"></i>&nbsp;Update Event Details
                      </DropdownItem>
                      <DropdownItem
                        disabled={showLoaderForDeleteEvent}
                        onClick={flag ? this.handleDelete : undefined}
                        style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
                        className="theme-red"
                      >
                        <i className="wb webconnect-trash-regular"></i>&nbsp;Delete Event
                        {flag ? null : (
                          <>
                            &nbsp;
                            <TooltipInfo
                              title={description}
                              headerText={`Permission Disabled!`}
                              showHeader={true}
                              showArrow={true}
                            />
                          </>
                        )}
                        <CustomLoader loading={showLoaderForDeleteEvent} />
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>

              {selectedEvent.uuid && (
                <NewEventAction
                  events={events}
                  actions={actions}
                  projectId={projectId}
                  version={version}
                  eventActions={selectedEvent.actions}
                  selectedAction={selectedAction}
                  showLoaderForAction={showLoaderForAction}
                  showLoaderForDeleteAction={showLoaderForDeleteAction}
                  showLoaderForSwapAction={showLoaderForSwapAction}
                  showLoaderForEnableAction={showLoaderForEnableAction}
                />
              )}
            </div>
          </div>
        </div>
        <ParentDocCard>
          <h5>
            <b>About Events </b>
          </h5>
          <p>
            In DrapCode, events are the automated workflows that allow you to set the automated
            sequence of actions. You can create different types of automated workflow events such as
            saving, deleting or updating data in a collection, show/close modal, etc.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-event/event-introduction" />
          <br />
          <br />
        </ParentDocCard>
        {
          <Modal
            isOpen={isOpenEventUpdateModel}
            toggle={actions.toggleEventUpdate}
            backdrop="static"
          >
            <ModalHeader toggle={actions.toggleEventUpdate} className="border-bottom">
              <strong>Update Event Details</strong>
            </ModalHeader>
            <ModalBody>
              <EventForm
                actions={actions}
                projectId={projectId}
                version={version}
                event={selectedEvent}
                showLoader={showLoader}
                showLoaderForDeleteEvent={showLoaderForDeleteEvent}
                history={this.props.history}
                isUpdateForm={true}
              />
            </ModalBody>
          </Modal>
        }
      </>
    );
  };

  render() {
    const { loadEventDetailPending } = this.props.events;
    return (
      <div className="events-create-event">
        <div className="main">
          <div className="section">
            <div className="container">
              <div className="row mx-auto">
                {loadEventDetailPending ? (
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="text-center">
                      <CustomLoader loading={loadEventDetailPending} size="20px" color="#303453" />
                    </div>
                  </div>
                ) : (
                  this.showEditEventForm()
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.events,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions, ...datasourceActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditEvent);
